import { StyledControlsOverview } from './styles';

import { theme } from '../../../styles/theme';
import { CircleIcon } from '../../Icons';

interface CarouselOverviewProps {
  cards: { id: string }[];
  activeIndex: number;
}

function CarouselOverview({ cards, activeIndex }: CarouselOverviewProps) {
  return (
    <StyledControlsOverview>
      {cards.map((card, index) => (
        <CircleIcon
          key={card.id}
          size="2xs"
          style={{
            transition: 'color 0.2s',
          }}
          color={activeIndex === index ? 'black' : theme.color.borderColor}
        />
      ))}
    </StyledControlsOverview>
  );
}

export { CarouselOverview };
